<template>
  <v-main>
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12" max-width="400">
            <v-toolbar color="#B7C9E9" flat>
              <v-toolbar-title>Admin Login</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-form ref="form" v-model="valid">
                <v-text-field
                  v-model="email"
                  color="purple"
                  :rules="emailRules"
                  label="Administrator E-mail"
                  prepend-icon="mdi-email"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="password"
                  label="Password"
                  prepend-icon="mdi-lock"
                  type="password"
                ></v-text-field>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    :disabled="!valid"
                    color="purple"
                    text
                    class="mr-4"
                    @click="validate"
                  >
                    Start
                  </v-btn>
                  <v-btn
                    color="purple"
                    text
                    class="mr-4"
                    @click="cancel"
                  >
                    Cancel
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
export default {
  data: () => ({
    valid: true,
    name: "",
    email: "",
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+\..+/.test(v) || "E-mail must be valid"
    ],
    passwordShow: false,
    password: "",
    passwordRules: [v => !!v || "Password is Required"],
    select: null,

    checkbox: false
  }),
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        const user = {
          email: this.email,
          password: this.password
        };
        this.$store.dispatch("AdminSignIn", user);
        this.$router.push("admingamecontroller");
      }
    },
    cancel() {
      this.$router.push("/");
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    }
  }
};
</script>
